function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.315 23.182h9.369a2.564 2.564 0 0 0 2.866-2.892v-7.866h-6.592a1.426 1.426 0 0 1-1.626-1.624V4.136H9.315a2.571 2.571 0 0 0-2.865 2.9V20.29a2.568 2.568 0 0 0 2.865 2.892zm5.81-12.041h6.337a2.4 2.4 0 0 0-.8-1.248l-4.808-4.87a2.34 2.34 0 0 0-1.239-.8v6.407a.455.455 0 0 0 .51.511zM14 14.085a.721.721 0 0 1 .738.712v2.9l-.062 1.309.659-.685.721-.729a.719.719 0 0 1 .492-.229.645.645 0 0 1 .677.65.651.651 0 0 1-.237.5l-2.417 2.233A.821.821 0 0 1 14 21a.8.8 0 0 1-.562-.255l-2.426-2.233a.651.651 0 0 1-.237-.5.645.645 0 0 1 .677-.65.737.737 0 0 1 .492.229l.721.729.668.685-.07-1.309V14.8a.721.721 0 0 1 .737-.715z",
  transform: "translate(-1.998 -1.659)"
});

function SvgDownloadFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Info bubble",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFilled);
export default __webpack_public_path__ + "static/media/download-filled.f19ff79b.svg";
export { ForwardRef as ReactComponent };